<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <!-- 搜索区域 -->
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24" >
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['platform.roleUser.columns.roleName']" :labelCol="{span: 5}" :wrapperCol="{span: 18, offset: 1}">
              <a-input :placeholder="language['common.pleaseInput']+language['platform.roleUser.columns.roleName']" v-model="queryParam.roleName" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['platform.roleUser.columns.roleCode']" :labelCol="{span: 5}" :wrapperCol="{span: 18, offset: 1}">
              <a-input :placeholder="language['common.pleaseInput']+language['platform.roleUser.columns.roleCode']" v-model="queryParam.roleCode" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="$store.getters.application.applicationType === 'platform'">
            <a-form-item :label="language['emp.apptype.entrance']">
              <a-select
                allowClear
                :placeholder="language['column.pleaseChoose']+language['emp.apptype.entrance']"
                v-model="queryParam.entranceCode"
              >
                <a-select-option v-for="(item,index) in entrances" :key="index.toString()" :value="item.entranceCode">
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="12" :sm="24">
               <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 21px">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </a-col>
          </span>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="margin: 5px 0 10px 2px">
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"

        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-has="'emppresets:userList'" @click="handleUserList(record)">{{language['emp.presets.userList']}}</a>
          <a-divider type="vertical" />
          <a v-has="'emppresets:presets'" @click="handlePreset(record)">{{language['emp.presets.presets']}}</a>

        </span>

      </a-table>
    </div>

<!--   -->
    <emp-role-application-modal ref="modalForm" @ok="modalFormOk"></emp-role-application-modal>
    <emp-role-app-user-list-modal ref="userListForm"  @ok="userListFormOk"></emp-role-app-user-list-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpRoleApplicationModal from './modules/EmpRoleApplicationModal'
  import moment from "moment";
  import EmpRoleAppUserListModal from './modules/EmpRoleAppUserListModal'
  import { httpAction } from '@/api/manage'

  export default {
    name: 'EmpRoleApplicationList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpRoleApplicationModal,
      EmpRoleAppUserListModal,
    },
    data () {
      return {
        description: 'emp_role_application管理页面',
        // 表头

        url: {
          //list: this.$store.getters.application.applicationType=='platform'?"/sys/role/list":"/sys/role/list?applicationId="+this.$store.getters.application.id,
          list: this.$store.getters.application.applicationType=='platform'?"/sys/role/emplist":"/sys/role/emplist?applicationId="+this.$store.getters.application.id,
          //list: "/hhemp/presets/emproleapplications",
          delete: "/hhemp/presets/emproleapplication",
          deleteBatch: "/hhemp/presets/emproleapplication/batch",
          exportXlsUrl: "/hhemp/presets/export-xls",
          importExcelUrl: "hhemp/presets/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
        entrances: [],
      }
    },
    created() {
      this.getSuperFieldList();
      this.getEntranceList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns(){
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title: this.language['platform.roleUser.columns.roleCode'],
              align: 'center',
              width:100,
              dataIndex: 'roleCode',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['platform.roleUser.columns.roleName'],
              align: 'center',
              width:150,
              dataIndex: 'roleName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['emp.presets.peopleCount'],
              align: 'center',
              width:100,
              dataIndex: 'userCount'
            },
            {
              title: this.language['emp.presets.presetsCount'],
              align: 'center',
              width:100,
              dataIndex: 'presetsCount'
            },
            {
              title: this.language['common.createTime'],
              dataIndex: 'createTime',
              width:150,
              align:"center",
              //sorter: true,
              customRender: (text) => {
                return text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : text
              }
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              width:100,
              align: 'center',
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'roleId',text:'角色id'})
        fieldList.push({type:'string',value:'applicationId',text:'应用id'})
        fieldList.push({type:'int',value:'sortNo',text:'排序'})
        fieldList.push({type:'string',value:'remark',text:'备注'})
        this.superFieldList = fieldList
      },
      handleUserList(record) {
        this.$refs.userListForm.title = this.language['emp.presets.userList']
        this.$refs.userListForm.listdetail(record.id,record.roleName)
      },
      handlePreset(record) {
        this.$refs.modalForm.title = this.language['emp.presets.presets']
        this.$refs.modalForm.preset(record.id,record.roleName,record.apps,record.applicationCode)
      },
      userListFormOk() {

      },
      getEntranceList(){
        httpAction("/hhemp/entrance/empcmsentrances?status=Y", "", "get").then((res) => {
          if (res.success) {
            this.entrances = res.result;
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
